import { render, staticRenderFns } from "./CustomerRef.vue?vue&type=template&id=9773b67e&scoped=true&"
import script from "./CustomerRef.vue?vue&type=script&lang=js&"
export * from "./CustomerRef.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRef.vue?vue&type=style&index=0&id=9773b67e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9773b67e",
  null
  
)

export default component.exports